import { FC } from 'react';
import style from './skeleton.module.css';

interface SkeletonProps {
  /** 高さ（px / % / rem など CSS の長さ） */
  height?: string;
  /** 幅（未指定は 100%） */
  width?: string;
  /** 角丸 */
  radius?: string;
  className?: string;
}

/**
 * 読み込み中のプレースホルダ。
 * Framework7 標準の skeleton-effect-wave を使うため追加ライブラリは不要。
 */
export const Skeleton: FC<SkeletonProps> = ({
  height = '16px',
  width = '100%',
  radius = '4px',
  className = '',
}) => (
  <div
    className={`skeleton-effect-wave ${style['skeleton']} ${className}`}
    style={{ height, width, borderRadius: radius }}
  />
);

interface SkeletonTextProps {
  /** 行数 */
  lines?: number;
  className?: string;
}

/** 複数行のテキスト用プレースホルダ（最終行だけ短くする） */
export const SkeletonText: FC<SkeletonTextProps> = ({
  lines = 3,
  className = '',
}) => (
  <div className={`${style['skeleton-text']} ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        height="12px"
        width={i === lines - 1 ? '60%' : '100%'}
      />
    ))}
  </div>
);
